@if (filterForm != null) {
    <h2 class="expand-header" [class.expanded]="this.filterForm().expanded().value()" (click)="toggleExpanded()">Boligtyper</h2>

    <div class="expander estateTypes" [class.expanded]="this.filterForm().expanded().value()">
        <div class="container">
            <div class="left">
                <ul>
                    @for (estateType of this.filterForm().estateTypes; track $index) {
                        @if (!estateType().value().other) {
                            <li class="check-box" (click)="toggleSelectedEstate(estateType().value())">
                                <div class="estate-icon {{ estateType.estateType().value().toString() }}"></div>
                                <input
                                    type="checkbox"
                                    class="checkbox-icon"
                                    [formField]="estateType.selected"
                                    [class.selected]="estateType.selected().value()"
                                />
                                <label> {{ estateType.estateType().value().toString() }} </label>
                            </li>
                        } @else {
                            <li class="check-box" (click)="toggleSelectedEstate(estateType().value())">
                                <div class="estate-icon Annet"></div>
                                <input
                                    type="checkbox"
                                    class="checkbox-icon"
                                    [formField]="estateType.selected"
                                    [class.selected]="estateType.selected().value()"
                                />
                                <label> Andre </label>
                            </li>
                        }
                    }
                </ul>
            </div>
            <div class="right">
                <div class="select-all-btn" data-cy="click-all" (click)="selectAllEstateTypes()">
                    <label>Alle</label>
                </div>
            </div>
        </div>
    </div>
}
